/** Marketing / public site URLs (set REACT_APP_ABOUT_URL in .env) */
export const ABOUT_PAGE_URL =
  process.env.REACT_APP_ABOUT_URL ?? "https://justis.africa/about";
